module.exports = __webpack_public_path__ + "img/4_98.a1274303.png";